/**
 * @ngdoc service
 * @name  common.service:cmsService
 * @description
 * 
 * # Servicio del nuevo CMS  
 */

(function () {
    'use strict';

    angular
        .module('itxApp.help')
        .factory('cmsService', cmsService);

    cmsService.$inject = [
        '$q', 
        '$http', 
        'ItxScreenSizeSvc', 
        'itxAkamaiSvc', 
        'itxCmsUtilsSvc',  
        'ItxHeaderFct', 
        'timestampSvc',
        'ItxApiSvc',
        'imHomeService',
        'ItxConfigurationSvc'
    ];
    
    function cmsService(
        $q, 
        $http, 
        ItxScreenSizeSvc, 
        itxAkamaiSvc, 
        itxCmsUtilsSvc, 
        ItxHeaderFct, 
        timestampSvc,
        ItxApiSvc,
        imHomeService,
        ItxConfigurationSvc
    ) {

        var _this = this;
        
        _this.date = {};
        _this.language = inditex.iLocale.substring(0, 2).toLowerCase();
        _this.country = inditex.iCountryCode;
        _this.device = _getCurrentDevice();

        _this.section = ItxHeaderFct.getLastSection();


        _this.contentsPath = ItxConfigurationSvc.getCmsStaticPath() + '/contents';
        

        var sectionActive = 'none';

        var service = {
            get: _get,
            getContent: _getContent,
            redirectTo: _redirectTo,
            getLink: getLink,

            // TODO gestiona las secciones del list category en Mobile
            hasSectionActive: _hasSectionActive,
            setSectionActive: _setSectionActive,
            getSubcategories: _getSubcategories,

            createEventAnalitics: _createEventAnalitics
        };
        return service;

        /**
         * @ngdoc method
         * @methodOf common.service:cmsService
         * @name redirect
         * @param {object} typeLink Debe recibir el objecto Link del CMS con un type y src validos.
         * @description 
         * Redirecciona a url absoluta y id's de categoria
        */
        function _redirectTo(link) {
    
            switch(link.type){
                case 'categoryLink':
                    itxCmsUtilsSvc.goToCategory(link.src, true);
                    break;
                case 'externalLink':
                    window.location.href = link.src;
                    break;
            }
        }


        /**
         * @ngdoc method
         * @methodOf common.service:cmsService
         * @name get
         * @description 
         * Devuelve el Json completo
        */
        function _get(directory) {
            var deferred = $q.defer();
            if(directory){
                $http.get(_this.contentsPath +'/'+ directory + '/' + _getCurrentDevice() + '/' + _getNameJson() + '?' + timestampSvc.getTs() )
                    .then(function (res) {
                        deferred.resolve(res.data);
                    })
                    .catch(function (error) {
                        deferred.reject(error);
                    });
            } else {
                deferred.reject('NO EXISTE GENERO PARA DESCARGAR EL JSON SEGMENTADO');
            }
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @methodOf common.service:cmsService
         * @name get
         * @param {string} gender Si le envías el género (women, men o boys & girls) te devuelve el Json segmentado.
         * sinó le pasas género irá a buscarlo a localStorage y sino lo tenemos guardado te devuelve mensaje de error.
         * @return {promise} promise
         * @description
         * Filtra el content del Json según los criterios de hora, dia etc ...
        */
        function _getContent(directory) {
            var deferred = $q.defer();
            
            // Sino existe directorio asigno el LAST_SECTION 
            if(!directory){
                directory = _getGender();
            }

            _get(directory)
            .then(function (response) {
                itxAkamaiSvc.getDate()
                .then(function (date) {
                    _this.date = date;
                    _filterCurrentSegment(response.segments).then(function (res) {
                        deferred.resolve(res);
                    });
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            })
            .catch(function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function _getGender() {
            // TODO NAME RES
            var res = '3';
            if(_this.section == 'MEN'){
                res = '4';
            }
            if(_this.section == 'BG'){
                res = '5';
            }
            return res;
        }

        function _getNameJson() {
            return _getCountryCode() + '-' + _this.language + '.json';
        }

        function _getCountryCode() {
            if (!inditex.iStoreJSON || inditex.iCountryCode === 'WW') {
                return inditex.iCountryCode;
            } else {
                return inditex.iStoreJSON.countryCode;
            }
        }

        function _filterCurrentSegment(arraySegments) {
            var content = [];
            var deferred = $q.defer();
            _.each(arraySegments, function (segment, index) {
                if(_criteriaFilter(segment.criteria)){
                    segment.content.id = segment.id; 
                    content.push(segment.content);
                }
                if(index + 1 == arraySegments.length) {
                    deferred.resolve(content);
                }
            });
            return deferred.promise;
        }

        function _criteriaFilter(criteria){
            var res;
            if (_.isEmpty(criteria)){
                return true;
            } else {
                var res =  true;
                if(criteria.dates){
                    res  = res && _criteriaDate(criteria) 
                }
                if(criteria.countries){
                    res =  res && _criteriaCountry(criteria);
                }
                if(criteria.languages){
                    res =  res && _criteriaLanguage(criteria);
                }
                
            }
            return res;
        }
        
        function _criteriaDate(criteria){
            var res = false;
            var currentTimestamp = _this.date.toDate().getTime();
            if(criteria.dates){
                if(criteria.dates.length === 0){
                    res = true;
                } else {
                    _.each(criteria.dates, function (date) {
                        if(date.fromDate < currentTimestamp && date.toDate > currentTimestamp){
                            res = true;
                            return;
                        }
                    });
                }
            }
            return res;
        }
        
        function _criteriaCountry(criteria){
            var res = false;
            if(criteria.countries.length === 0){
                res = true;
            } else {
                res = criteria.countries.indexOf(_this.country) > -1;
            }
            return res;
        }
        
        function _criteriaLanguage(criteria){
            var res = false;
            if(!criteria.languages || criteria.languages.length === 0){
                res = true;
            } else {
                res = criteria.languages.indexOf(_this.language) > -1;
            }
            return res;
        }

        function _criteriaDevice(criteria){
            var res = false;
            if(criteria.devices){
                if(criteria.devices.length === 0){
                    res = true;
                } else {
                    res = criteria.devices.indexOf(_this.device) > -1;
                }
            }
            return res;
        }
        /**
        * @ngdoc method
        * @name _getCurrentDevice
        * @methodOf common.service:cmsService
        * @description
        * Choose the json path based in the current device.
        * NOTICE: The CMS has problems generating the json in differents
        * devices. For that reason, will always return the ``mobile`` path.
        * @returns {string} device path name
        */
        function _getCurrentDevice(){
            return 'mobile';

            // var res = 'desktop';
            // if(ItxScreenSizeSvc.is('xs')){
            //     res = 'mobile';
            // } else if(ItxScreenSizeSvc.is('sm')){
            //     res = 'tablet';
            // }
            // return res;
        }

        function _hasSectionActive(type) {
            
            return sectionActive != type; 
        }

        function _setSectionActive(type) {
            sectionActive = type;
            
        }

        function _getSubcategories(value) {
            var deferred = $q.defer();

            var categories = inditex.iCategoryTreeJSON.categories;
            _.each(categories, function(category) {
                _.each(category.subcategories, function (subcategory) {
                    if (subcategory.id == value){
                        deferred.resolve(category);
                        return;
                    }
                    if(subcategory.subcategories.length > 0){
                        _.each(subcategory.subcategories, function (_subcategory) {
                            if (_subcategory.id == value){
                                deferred.resolve(category);
                                return;
                            }
                        });
                    }
                });
            });
            return deferred.promise;
        }


        function getLink(text){
            if(!text.entityMap || typeof text.entityMap != 'object' ||  text.entityMap.length==0 || !text.entityMap[0].data || !text.entityMap[0].data.src) {
            
                return '';
            }

            return text.entityMap[0].data.src;
        }

        function _createEventAnalitics(categoryId, pageCms){
            // Con estas peticiones se cargan las variables necesarias para generar el pagename en los servicios de analitics
            // Podemos revisar lo que se ha generado en JSON.parse(inditex.getSessionStorage('dataObject')).category
            ItxApiSvc.getCategoryTree().then(function(){
                var iCategoryTreeJSON = inditex.iCategoryTreeJSON && inditex.iCategoryTreeJSON.categories;
                inditex.iCategoryJSON = joyr.catalog.utils.findCategoryById(categoryId, iCategoryTreeJSON);
                imHomeService.createEventCms(pageCms);
            });
        }

    }

})();